import React, { useEffect, useState } from 'react'
import {
  Avatar, Container, Grid, Typography, IconButton, Tooltip, Skeleton, Badge, Button, Box, Chip
} from '@mui/material'
import { ClassNameMap, withStyles, makeStyles, } from '@mui/styles'
import stylesheet from '../detail-container.stylesheet'
import avatar from '../../../../assets/Profile-pic1.jpg'
import { ReactComponent as ExpanIcon } from '../../../../assets/ExpanIcon.svg'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { ReactComponent as CollapseIcon } from '../../../../assets/CollapseIcon.svg'
import { ReactComponent as CollapseHoverIcon } from '../../../../assets/CollapseHoverIcon.svg'
import { ReactComponent as ExpandHoverIcon } from '../../../../assets/ExpandHoverIcon.svg'
import { useSelector } from 'react-redux'
import { RootState, useAppThunkDispatch } from '../../../../redux/store'
import { setAddValue } from '../../../../redux/add-control-slice'
import { checkCondition } from '../common/condition-check'
import EditIcon from '@mui/icons-material/Edit'
import PhoneForwardedIcon from '@mui/icons-material/PhoneForwarded'
import { getZoomPhoneUri } from '../../../../utils/phone-utils'
import EditProfileModal from './edit-profile-modal'
import ErrosDialogComponent from '../info-header/patient-errors.component';
import moment from 'moment'
import { toast } from 'react-toastify'
import Helper from '../../../../utils/helper'
import { RPMActivityTimer } from '../rpm'
import PortalInviteMenu from './portal-invite-menu.component'

const useStyles = makeStyles(() => ({
  paddingClass: {
    padding: '0 2rem 0 2rem',
    // [theme.breakpoints.up('lg')]: {
    //   padding: '0 2rem 0 2rem',
    // },
    // [theme.breakpoints.down('xs')]: {
    //   margin: 0,
    //   padding: '0 0 0 0.5rem',

    '& > .MuiGrid-item': {
      padding: '0 0 0.5rem 0',
      margin: 0,
    },
    //   },
  },
}))

interface IProps {
  classes: ClassNameMap
  handleClick: any
}

const MultiProgramInfoHeaderComponent: React.FC<IProps> = ({
  classes,
  handleClick,
}) => {
  const classess = useStyles()
  const patientDetails = useSelector((state: RootState) => state.patientDetail.patientDetail)
  const dispatch = useAppThunkDispatch()
  const addButtons: any = useSelector((state: RootState) => state.addButtons)
  const [showTimeline, setShowTimeline] = useState(false)
  const [editProfile, setEditProfile] = useState(false)
  const [isOpen, setIsOpen] = useState(false)
  const [isShowErrors, setIsShowErrors] = useState(false)

  useEffect(() => {
    if (isOpen)
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }, [isOpen])


  useEffect(() => {
    if (patientDetails?.error_data && Object.keys(patientDetails?.error_data)?.length > 0) {
      const details = <Typography variant="body2">{`Patient loaded with error.`}</Typography>
      toast.error(details, Helper.bottom_center())
    }
  }, [patientDetails])

  const handleShowErrors = () => setIsShowErrors(true)
  const handleDialogClose = () => setEditProfile(false)
  const handleErrDialogClose = () => setIsShowErrors(false)


  const ShowJourneyIcon = checkCondition(
    isOpen,
    checkCondition(showTimeline, CollapseHoverIcon, CollapseIcon),
    checkCondition(showTimeline, ExpandHoverIcon, ExpanIcon)
  )

  const getPendingCount = () => {
    let count = 0
    if (patientDetails?.birthdate === null || patientDetails?.birthdate === '')
      count++
    if (patientDetails?.c_sex === null || patientDetails?.c_sex === '')
      count++
    return count
  }

  const renderEdit = () => <EditIcon
    className={classes.editProfileIcon}
    onClick={() => setEditProfile(true)}
    sx={{ fontSize: '18px', color: patientDetails.needs_update === true ? 'var(--color-primary)' : 'inherit' }}
  />

  const handleAddHidePatientJourney = () => {
    const temp = [
      ...addButtons?.addControl.map((e: any) =>
        checkCondition(e.key === 'PA-JOR', { ...e, value: !e.value }, e)
      ),
    ]
    dispatch(setAddValue(temp))
    setIsOpen(!isOpen)
  }

  return (
    <>
      <Container maxWidth="xl" disableGutters={true}>
        <Grid container spacing={1} className={`${classess.paddingClass}`} justifyContent="space-around">
          <Grid item style={{ width: '24%' }} className={classes.topHead}>
            <IconButton
              disabled={patientDetails.sf_patient_deeplink === null}
              href={patientDetails.sf_patient_deeplink}
              target="_blank"
              style={{ padding: '0px' }}
            >
              <Avatar
                variant="square"
                className={classes.avatarPic}
                src={avatar}
                style={patientDetails.sf_patient_deeplink
                  ? { borderColor: '#3C97DD' }
                  : { borderColor: '#CBC7C780' }
                }
              />
            </IconButton>
            <Box className={classes.topNameDet}>
              {checkCondition(
                patientDetails && (patientDetails.given_name || patientDetails.family_name),
                <Grid container justifyContent="space-between" className={classes.multiProgramInfoContainer}>
                  <Grid item className={classes.multiProgramInfoHeader}>
                    <Typography className={[classes.topBarDetails1, classes.patientNameTop].join(' ')}>
                      {`${patientDetails.given_name} ${patientDetails.family_name || ''}`}
                    </Typography>
                    {((patientDetails?.birthdate === null || patientDetails?.birthdate === '')
                      || (patientDetails?.c_sex === null || patientDetails?.c_sex === '')
                    ) ?
                      <Badge badgeContent={getPendingCount()}
                        variant="standard"
                        color="warning"
                        sx={{ margin: '0.3rem 0.6rem 0 0' }}
                      >
                        {renderEdit()}
                      </Badge>
                      : renderEdit()
                    }
                  </Grid>
                </Grid>,
                <Grid container justifyContent="space-between" className={classes.multiProgramInfoContainer}>
                  <Grid item className={classes.multiProgramInfoHeader}>
                    {renderEdit()}
                  </Grid>
                </Grid>
              )}
              <Typography className={classes.ageGenderMrn}>
                {patientDetails.race || patientDetails.sex || patientDetails.birthdate
                  ? (
                    <>
                      {checkCondition(patientDetails.sex, `${patientDetails.sex}, `, '')}
                      {' '}
                      {checkCondition(patientDetails.birthdate, `${moment(patientDetails.birthdate).format('MMM DD YYYY')} `, '')}
                      {' '}
                      {checkCondition(patientDetails.age, `(${patientDetails.age} yrs), `, '')}
                      {' '}
                      {checkCondition(patientDetails.ref_id, `${patientDetails.ref_id} `, '')}
                    </>
                  ) : (
                    <>-</>
                  )}
              </Typography>
              {patientDetails?.elation_source && (
                <Chip
                  label={patientDetails.elation_source === 'lifemd' ? 'LifeMD' : 'Atman'}
                  size="small"
                  color={patientDetails.elation_source === 'lifemd' ? 'secondary' : 'primary'}
                  variant="outlined"
                  sx={{ height: '16px', fontSize: '0.6rem', mt: 0.3 }}
                />
              )}
            </Box>
            <ShowJourneyIcon
              onClick={(_e: any) => handleAddHidePatientJourney()}
              onMouseOver={() => setShowTimeline(true)}
              onMouseOut={() => setShowTimeline(false)}
              className={classes.downArrowIcon}
            />
          </Grid>
          <Grid item style={{ width: '14%' }} className={classes.email}>
            <Typography className={classes.topBarHeads}>Synced on</Typography><br />
            <Typography className={classes.topBarDetails1}>
              {patientDetails?.last_sync_date
                ? moment.unix(patientDetails?.last_sync_date).format("MMM DD, YYYY h:mm a")
                : '-'
              }
            </Typography>
          </Grid>
          <Grid item style={{ width: '16%' }} className={classes.email}>
            <Typography className={classes.topBarHeads}>Email</Typography><br />
            {patientDetails && patientDetails.email ? (
              <Tooltip title={patientDetails?.email} placement="bottom">
                <Typography title={patientDetails?.email} className={classes.topBarDetails1}>
                  {patientDetails.email}
                </Typography>
              </Tooltip>
            ) : (
              <Typography className={classes.topBarDetails1}> - </Typography>
            )}
          </Grid>
          <Grid item style={{ width: '13%' }} className={classes.email}>
            <Typography className={classes.topBarHeads}>Mobile</Typography><br />
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
              <Tooltip title={patientDetails?.phone} placement="bottom">
                <Typography className={classes.topBarDetails1} title={patientDetails?.phone}>
                  {checkCondition(patientDetails.phone, patientDetails.phone, '-')}
                </Typography>
              </Tooltip>
              {patientDetails.phone && (
                <Tooltip title="Call with Zoom Phone" placement="bottom">
                  <IconButton
                    size="small"
                    href={getZoomPhoneUri(patientDetails.phone)}
                    sx={{ padding: '2px' }}
                  >
                    <PhoneForwardedIcon sx={{ fontSize: 16, color: 'var(--color-link) !important' }} />
                  </IconButton>
                </Tooltip>
              )}
            </Box>
          </Grid>
          <Grid item style={{ width: '14%' }} className={classes.email}>
            <Typography className={classes.topBarHeads}>MRN</Typography> <br />
            <Tooltip title={patientDetails?.mrns?.join()} placement="bottom">
              <Typography className={classes.topBarDetails1}>{patientDetails?.mrns?.join() || '-'}</Typography>
            </Tooltip>
          </Grid>
          <Grid item style={{ width: '5%', display: 'flex', alignItems: 'flex-start', paddingTop: '1.25rem' }}>
            <RPMActivityTimer />
          </Grid>
          {patientDetails?.ref_id && (
            <Grid item style={{ width: '3%', display: 'flex', alignItems: 'flex-start', paddingTop: '0.85rem' }}>
              <PortalInviteMenu patientRefId={patientDetails.ref_id} />
            </Grid>
          )}
          {patientDetails?.error_data && Object.keys(patientDetails?.error_data)?.length > 0 &&
            <Grid item style={{ width: '3%' }}>
              <Tooltip title={'Show errors'} placement="bottom" className={classes.email}>
                <ErrorOutlineIcon
                  sx={{ marginTop: '0.5rem', fill: 'rgb(249 0 0)', cursor: 'pointer' }}
                  fontSize="small"
                  onClick={handleShowErrors} />
              </Tooltip>
            </Grid>
          }
        </Grid>
      </Container>
      {editProfile &&
        <EditProfileModal
          open={editProfile}
          patientId={patientDetails.id}
          handleDialogClose={handleDialogClose}
        />
      }
      {isShowErrors &&
        <ErrosDialogComponent
          open={isShowErrors}
          item={{
            title: 'Error Details',
            data: patientDetails?.error_data
          }}
          handleDialogClose={handleErrDialogClose}
        />
      }
    </>
  )
}

export default withStyles(stylesheet)(MultiProgramInfoHeaderComponent)
